<div class="content">
    @for (f of field.fieldGroup; track f) {
    <formly-field [field]="f"></formly-field>
    }
</div>